import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { getAsset } from '../../../../util/assets';
import IntroSlideLabel from '../../../pro/views/Album/MemoryBookAlbum/components/MemoryBookIntroSlide/components/IntroSlideLabel';

const propTypes = {
  className: PropTypes.string,
  linkTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  isDisabled: PropTypes.bool,
  isActive: PropTypes.bool,
  thumbnailUrl: PropTypes.string,
  thumbnailActions: PropTypes.node,
  entityId: PropTypes.string,
  note: PropTypes.string,
  linkProps: PropTypes.shape({
    rel: PropTypes.string,
  }),
};

const WebGalleryCard = ({
  className,
  linkTo,
  onClick,
  icon,
  title,
  subtitle,
  isDisabled,
  isActive,
  thumbnailUrl,
  thumbnailActions,
  entityId,
  note,
  linkProps,
}) => {
  const classes = classNames({
    'web-gallery-card': true,
    'has-thumbnail': !!thumbnailUrl,
    'is-disabled': isDisabled,
    'is-active': isActive,
    [className]: !!className,
  });

  const TemplateLink = ({ children }) => (
    <Link
      to={linkTo}
      className="web-gallery-card-link"
      onClick={event => {
        if (isDisabled) {
          event.preventDefault();
        }

        onClick?.();
      }}
      {...(linkProps ?? {})}
    >
      {children}
    </Link>
  );

  const thumbnail = (() => {
    if (!thumbnailUrl) {
      return (
        <TemplateLink>
          {!icon && (
            <div className="web-gallery-card-cover-null-state">
              <img
                alt="Waldo logo"
                className="m-auto d-flex grayscale-faded"
                width="60px"
                src={getAsset('/waldo-icon.svg')}
              />
              <p className="text-extra-bold  text-center text-dark pt-4">
                No photos here yet
              </p>
            </div>
          )}
        </TemplateLink>
      );
    }

    return (
      <TemplateLink>
        <img
          src={thumbnailUrl}
          alt={title}
          className="web-gallery-card-cover-img"
        />
        <IntroSlideLabel albumId={entityId} />
      </TemplateLink>
    );
  })();

  return (
    <div className={classes}>
      <figure className="web-gallery-card-cover">
        {thumbnail}

        {icon && <span className="web-gallery-card-cover-icon">{icon}</span>}

        {thumbnailActions && (
          <div className="web-gallery-card-thumbnail-actions">
            {thumbnailActions}
          </div>
        )}

        {note && <div className="web-gallery-card-thumbnail-note">{note}</div>}
      </figure>

      <div className="web-gallery-card-content">
        <TemplateLink>
          <p className="web-gallery-card-title">{title}</p>

          {subtitle && (
            <div className="web-gallery-card-content-footer">
              {subtitle && (
                <span className="web-gallery-card-subtitle">{subtitle}</span>
              )}
            </div>
          )}
        </TemplateLink>
      </div>
    </div>
  );
};

WebGalleryCard.propTypes = propTypes;

export default WebGalleryCard;
